/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "El Centro de la Amistad",
      "Encuentra nuevas amistades con la app de Bumble For Friends| Bumble",
      "Descargar en App Store",
      "Descargar en Google Play",
      "Un espacio dedicado a hacer nuevas amistades",
      "Descubre gente cerca de ti que está aquí para crear conexiones auténticas.",
      "Haz amistades en cualquier etapa de tu vida",
      "¿Acabas de mudarte? ¿Necesitas empezar de cero? ¡Un nuevo grupo te espera!",
      "Un espacio seguro",
      "Te damos la bienvenida a un espacio de respeto, donde puedes ser tú.",
      "Descarga la aplicación",
      "¡Conecta con gente a la que le gusta lo mismo que a ti!",
      "Conecta con nuevas personas con los Plans de Bumble For Friends",
      "Tienes una invitación para unirte a Planes",
      "Plans es una nueva función de Bumble For Friends en la que puedes crear o unirte a reuniones con nuevas amistades cerca de ti",
      "Gestionar cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
